import { pxToRem } from '../../../../utils';
var carouselStyles = {
  root: function root() {
    return {
      display: 'inline-block'
    };
  },
  itemsContainerWrapper: function itemsContainerWrapper(_ref) {
    var v = _ref.variables,
        p = _ref.props;
    return Object.assign({
      display: 'flex',
      width: pxToRem(v.width),
      overflowX: 'hidden',
      border: '1px solid transparent'
    }, p.shouldFocusContainer && p.isFromKeyboard && {
      border: "1px solid ".concat(v.focusOuterBorderColor),
      borderRadius: v.focusOuterBorderRadius
    });
  },
  itemsContainer: function itemsContainer() {
    return {
      padding: 0,
      margin: 0,
      display: 'flex',
      listStyle: 'none',
      willChange: 'transform'
    };
  },
  paddleNext: function paddleNext(_ref2) {
    var p = _ref2.props,
        v = _ref2.variables;
    return Object.assign({
      height: pxToRem(v.paddleNextSize),
      top: pxToRem(-v.height / 2 - v.paddleNextSize / 2),
      left: pxToRem(v.width - 2 * v.paddleNextSize)
    }, p.items !== undefined && {
      visibility: !p.circular && p.activeIndex === p.items.length - 1 ? 'hidden' : 'visible'
    });
  },
  paddlePrevious: function paddlePrevious(_ref3) {
    var p = _ref3.props,
        v = _ref3.variables;
    return Object.assign({
      height: pxToRem(v.paddlePreviousSize),
      top: pxToRem(-v.height / 2 - v.paddlePreviousSize / 2)
    }, p.items !== undefined && {
      visibility: !p.circular && p.activeIndex === 0 ? 'hidden' : 'visible'
    });
  }
};
export default carouselStyles;